import {
  TrainingCategoryApiRequest,
  UpdateTrainingCategoryRequest,
} from '@/data/payload/api/TrainingCategoryRequest'
import {
  PostTrainingCategoryInterface,
  DeleteTrainingCategoryInterface,
  UpdateTrainingCategoryInterface,
} from '@/data/payload/contracts/TrainingCategoryRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { TrainingCategoryDataMapper } from '@/data/persistences/mappers/TrainingCategoryDataMapper'
import { TrainingCategoryRepositoryInterface } from '@/data/persistences/repositories/contracts/TrainingCategoryRepositoryInterface'
import { TrainingCategory } from '@/domain/entities/TrainingCategory'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class TrainingCategoryApiRepository
  implements TrainingCategoryRepositoryInterface {
  private service: ApiService
  private mapper: TrainingCategoryDataMapper

  constructor(service: ApiService, mapper: TrainingCategoryDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(
    payload: DeleteTrainingCategoryInterface
  ): Promise<TrainingCategory> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.TRAINING_CATEGORY_DELETE,
      undefined,
      payload as TrainingCategoryApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(
    payload: PostTrainingCategoryInterface
  ): Promise<TrainingCategory> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.TRAINING_CATEGORY,
      undefined,
      payload as TrainingCategoryApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateTrainingCategoryInterface,
    id: number
  ): Promise<TrainingCategory> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.TRAINING_CATEGORY}/${id}`,
      undefined,
      payload as UpdateTrainingCategoryRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<TrainingCategory> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.TRAINING_CATEGORY,
      params
    )
    return this.mapper.convertFromApi(resp)
  }
}
